<script>
import {
  CdrImg, CdrGrid,
} from '@rei/cedar';
import StoreMapComponent from '../commons/StoreMapComponent.vue';
import VirtualTourButton from '../commons/VirtualTourButton.vue';

export default {
  name: 'StoreMediaComponent',
  components: {
    VirtualTourButton,
    CdrImg,
    CdrGrid,
    StoreMapComponent,
  },
  props: {
    storeMediaData: {
      type: Object,
      required: true,
    },
  },
};
</script>
<template>
  <cdr-grid class="store-media-grid">
    <div>
      <div
        class="storeImage"
      >
        <cdr-img
          :src="storeMediaData.storeImageUrl"
          :alt="storeMediaData.storeImageAlt"
          ratio="square"
          class="hero__image"
          data-ui="department-hero-image"
        />
        <virtual-tour-button
          :virtual-tour-link-model="storeMediaData.virtualTourLinkModel"
          class="virtualTour"
        />
      </div>
    </div>
    <div>
      <div class="storeMap">
        <store-map-component
          :map-data="storeMediaData.storeGoogleMapModel"
          size-width="320"
          size-height="320"
        />
      </div>
    </div>
  </cdr-grid>
</template>
<style lang="scss">
  @import "@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss";
  .store-media-grid {
    width: 100%;
    margin-bottom: $cdr-space-two-x;
    grid-template-columns: 1fr 1fr;
  }
</style>